:root {
  --color-primary: #e60576;
  --color-primary-20: #e6057633;

  --color-secondary: #367bff;
  --color-secondary-10: #367bff1a;
  --color-secondary-60: #367bff3c;

  --color-success: #38c2b8;
  --color-success-10: #38c2b81a;
  --color-success-60: #38c2b83c;

  --color-error: #eb5163;
  --color-error-10: #eb51631a;
  --color-error-60: #eb51633c;

  --color-warning: #f8a72d;
  --color-warning-10: #f8a72d1a;
  --color-warning-60: #f8a72d3c;

  --color-grey-1: #e4e6ea;
  --color-grey-2: #cacdd5;
  --color-grey-3: #afb4c0;
  --color-grey-4: #959bab;
  --color-grey-5: #7a8296;
  --color-grey-6: #626878;
  --color-grey-7: #494e5a;
  --color-grey-7-5: #3c404a;
  --color-grey-8: #31343c;
  --color-grey-8-5: #25272d;
  --color-grey-8-75: #1d1f24;
  --color-grey-9: #181a1e;
  --color-grey-9-25: #141619;
  --color-grey-9-5: #0c0d0f;

  --color-text-grey-light: #aaa;
  --color-text-grey-dark: #3f4846;

  --transition-bg: background 0.1s ease-out 0s,
    box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;

  --bg-color-light: #27282b;
  --bg-color-dark: #1f2023;
  --bg-color-middle: #19191c;
  --bg-color-middle-hover: #27272b;
  --bg-color-dark-black: #000;

  --header-bg-color: #0a0909;
  --header-bg-color-active: #1f1f22;
  --header-project-color: #8a8f98;
  --header-height: 6.8rem;

  --tab-bar-height: 4rem;
  --header-tab-bg-color: blue;
  --header-tab-bg-color-active: #1f2023;
  --header-tab-bg-color-hover: rgba(255, 255, 255, 0.05);

  --home-drawer-bg-color: #27282b;
  --card-bg-color: #27282b;
  --card-bg-color-current: #d1d1d1;
  --card-border-color: #000000;
  --card-subtitle-color: #8a8f98;
  --card-subtitle-color-low: rgba(138, 143, 152, 0.4);
  --icon-hover: #a7b0ba;
  --card-header-color: #1f1f22;

  --button-bgcolor-default: var(--color-grey-8-5);
  --button-bgcolor-default-hover: var(--color-grey-7-5);
  --button-bgcolor-default-focus: var(--color-grey-7-5);
  --button-bgcolor-default-active: var(--color-grey-7-5);

  --button-bgcolor-primary: var(--color-secondary);
  --button-bgcolor-primary-hover: #0b53dc;
  --button-bgcolor-primary-focus: #0b53dc;
  --button-bgcolor-primary-active: #0b53dc;

  --button-bgcolor-success: var(--color-success);
  --button-bgcolor-success-hover: var(--color-success-60);
  --button-bgcolor-success-focus: var(--color-success-60);
  --button-bgcolor-success-active: var(--color-success-60);

  --button-bgcolor-warning: var(--color-warning);
  --button-bgcolor-warning-hover: var(--color-warning-60);
  --button-bgcolor-warning-focus: var(--color-warning-60);
  --button-bgcolor-warning-active: var(--color-warning-60);

  --button-bgcolor-danger: var(--color-error);
  --button-bgcolor-danger-hover: var(--color-error-60);
  --button-bgcolor-danger-focus: var(--color-error-60);
  --button-bgcolor-danger-active: var(--color-error-60);

  --elevation-1-dp: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 3px 0 rgba(0, 0, 0, 0.2);
  --elevation-2-dp: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  --elevation-8-dp: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12),
    0 5px 5px -3px rgba(0, 0, 0, 0.2);
  --elevation-16-dp: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12),
    0 8px 10px -5px rgba(0, 0, 0, 0.2);

  --button-rest-elevation: var(--elevation-2-dp);
  --button-hover-elevation: var(--elevation-16-dp);
  --button-pressed-elevation: var(--elevation-8-dp);

  --creative-space-hover: rgba(138, 143, 152, 0.3);
  --creative-space-list-header: #5f6164;

  --text-color-white: #f9f9f9;

  --drawer-width: 22rem;
  --drawer-width-closed: 6.4rem;

  --storyboard-drawer-width: 40rem;
  --storyboard-shot-card-bg-color: #303236;
  --storyboard-border-color: #0a0909;

  --card-border-radius: 0.6rem;
  --input-border-radius: 0.4rem;

  --step-title-color: #f7f8f8;
  --step-title-color-low: rgba(247, 248, 248, 0.1);
  --step-title-color-current: #5f6164;

  --date-color: rgba(247, 248, 248, 0.5);
  --date-border-color: var(--date-color);
  --date-bg-color-hover: #3d3e41;
  --date-bg-dark-color-hover: #737579;
  --date-dark-color: #42454b;
  --date-dark-color-hover: #b4b4b4;

  --select-bg-color: #1f2023;
  --select-border-color: #707070;
  --select-text-color: #8a8f98;

  --icon-fill: #bebebe;
  --icon-button-hover: #3d3e41;

  --header-dropdown-hover: #3d3e41;
  --header-dropdown-date-color: #8a8f98;

  --input-add-comment-text-color: #f7f8f8;
  --input-add-comment-bg-color: #42454b;

  --dialog-contant-bg-color: #1f1f22;

  --row-selected-color: #ffffff08;

  --strip-height: 6.4rem;

  --shot-strip-height: 12.5rem;

  --border-radius-small: 0.4rem;
  --border-radius-medium: 0.6rem;
  --border-radius-large: 0.8rem;
  --shooting-day-time-color: #8a8f98;
  --shooting-day-table-color-header: #5f6164;
  --shooting-day-table--bg-color: #42454b;
  --shooting-day-table-empty-bg-color: rgba(66, 69, 75, 0.3);
  --shooting-day-table-text-color: #8a8f98;
  --white-default: #ffffff;

  --grid-columns-2: repeat(2, 1fr);
  --grid-columns-3: repeat(3, 1fr);
  --grid-columns-4: repeat(4, 1fr);
  --grid-columns-5: repeat(5, 1fr);
  --grid-columns-6: repeat(6, 1fr);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

*:focus {
  outline: none;
  box-shadow: none;
}

html {
  font-size: 62.5%;
  height: 100vh;
  background-color: #f8f8fa;
  font-family: Inter, sans-serif;
}

#root,
body {
  height: 100vh;
}

/*

 */
#modal-root {
  position: absolute;
  top: 0;
  z-index: 99999;
}

#notification-root {
  top: 0;
  z-index: 99999;
}

#popover-root {
  top: 0;
  z-index: 99999;
}

a {
  text-decoration: none;
}

#modal-root::-webkit-scrollbar {
  width: 5px;
  overflow-y: scroll;
}

#modal-root::-webkit-scrollbar-track {
  border-radius: 1rem;
}

#modal-root::-webkit-scrollbar-thumb {
  background: rgb(48, 50, 54);
  border-radius: 10px;
}

/* Handle on hover */
#modal-root::-webkit-scrollbar-thumb:hover {
  background: rgb(48, 50, 54);
}

.columns {
  display: flex;
}

.customWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

/*************************
    SCROLLBAR
 *************************/
::-webkit-scrollbar {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  background-color: #36373d;
}

::-webkit-scrollbar-track {
  border-radius: 0.4rem;
}

::-webkit-scrollbar-thumb {
  background-color: #5f606b;
  border-radius: 0.4rem;
  width: 0.4rem;
}

::-webkit-scrollbar-thumb:hover {
  cursor: pointer;
}


.customCanvasHiddenButton {
  text-align: center;
}

.customCanvasHiddenButton {
  text-align: center;
}

.customCanvas {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.customCanvasPage {
  flex: auto;
  flex-grow: 1;
}

.react-pdf__Page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.customCanvas canvas {
  width: 100% !important;
  height: 100% !important;
}

.customCanvasSmall {
  flex: auto;
  flex-grow: 1;
  height: 100%;
}

.customCanvasSmall canvas {
  height: 100%;
}

.react-pdf__Page__canvas {
  background: #393939 !important;
}

/*input:-webkit-autofill,*/
/*input:-webkit-autofill:hover,*/
/*input:-webkit-autofill:focus,*/
/*textarea:-webkit-autofill,*/
/*textarea:-webkit-autofill:hover,*/
/*textarea:-webkit-autofill:focus,*/
/*select:-webkit-autofill,*/
/*select:-webkit-autofill:hover,*/
/*select:-webkit-autofill:focus {*/
/*  -webkit-text-fill-color: white;*/
/*  -webkit-box-shadow: 0 0 0 1000px rgb(25, 25, 25) inset;*/
/*  transition: background-color 5000s ease-in-out 0s;*/
/*}*/

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  background-color: var(--bg-color-dark) !important;
}

input::placeholder,
textarea::placeholder {
  color: #959bab;
}
